// extracted by mini-css-extract-plugin
export default {"multiselect":"m7N8cW"};